import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Type = iotsUtils.fromList(constants.user.preferences.uiSettingsTemplate.types);
